import { Col, Form, Row } from "antd";
import GeneralPhoneNumber2 from "apps/Common/GeneralPhoneNumber2";
import GeneralStoreInput from "apps/Common/GeneralStoreInput";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import { MazakaSwitch } from "apps/Common/MazakaSwitch";
import useMazakaForm from "hooks/useMazakaForm";
import { FC, useEffect, useState } from "react";
import {
  addPortfolioUserByStore,
  updatePortfolioUserByStore,
  updatePortfolioUserByStoreList,
} from "../../Services";
import { formatPhoneNumber } from "helpers/ConvertPhoneFormat";
import { getUserInfoesByPhoneNumber } from "apps/Account/Services";


interface AddOrUpdateUserProps {
  selectedRecord?: any | null;
  onFinish: any;
  type?: string;
}

const AddOrUpdateUser: FC<AddOrUpdateUserProps> = ({
  selectedRecord,
  onFinish,
  type,
}) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const [isFindUser, setIsFindUser] = useState(false);
  const [isLoadingFindUser, setIsLoadingFindUser] = useState(false);
  useEffect(() => {
    const data = { ...selectedRecord };
   
    if (data?.phoneNumber && data?.numberPrefix) {
      let unFormatedPhone = `${
        selectedRecord?.numberPrefix + selectedRecord.phoneNumber
      }`;
      let phone = formatPhoneNumber(unFormatedPhone);
      data["Phone"] = phone;
      data["storeIdList"] =
        selectedRecord?.storePortfolioUser?.map((item: any) => item?.storeId) ||
        [];
    }
    form.setFieldsValue({
      ...data,
    });

    console.log("sele",selectedRecord)
  }, [selectedRecord]);

  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    const formValues = form.getFieldsValue();
    if (!selectedRecord) {
      if (formValues["Phone"]?.includes("(")) {
        formValues["Phone"] = formValues["Phone"].replace(
          /^\+(\d{2})\((\d{3})\)\s*(\d+)$/,
          "$1+$2$3"
        );
      }
      let split_number = formValues["Phone"].split("+");

      let numberPrefix = split_number[0];
      let numberBody = split_number[1];

      formValues["phoneNumber"] = numberBody;
      formValues["numberPrefix"] = numberPrefix;
    }

    if (!formValues["password"]) {
      delete formValues["password"];
    }

    delete formValues["Phone"];
    try {
      if (selectedRecord) {

        let data = { ...selectedRecord };
        delete data["storePortfolioUser"];

        if(type==="edit-single-record")
          {
            const userData = {
              id: data?.portfolioUserId,
              insertDate: data.insertDate,
              updateDate: data.updateDate,
              name: data.name,
              surname: data.surname,
              phoneNumber: data.phoneNumber,
              numberPrefix: data.numberPrefix,
              eMail:data.eMail,
              profileName:data.profileName||"",
              profilePicture:data?.profilePictrue||"",
              isAuthPostAdvert:data.isAuthPostAdvert,
              storeId:data.storeId,
              ...formValues
            };
            await updatePortfolioUserByStore(userData)
          }
          else{
          const userInfoes = { ...data, ...formValues };
          await updatePortfolioUserByStoreList(userInfoes);

          setTimeout(()=>{},1000)

        }

       
      } else {
        await addPortfolioUserByStore(formValues);
      }
      mazakaForm.setSuccess(2000, () => "İşlem Başarılı");
      form.resetFields();

      onFinish();
    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message);
    }
  };

  return (
    <>
      <Col span={24}>
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          initialValues={{ isAuthPostAdvert: false, active: true }}
          onFinish={handleOnFinish}
        >
          <Row gutter={[10, 20]} className="">
            {!selectedRecord && (
              <>
                <GeneralPhoneNumber2
                  label={"Telefon Numarası"}
                  setInitialDataWithPhone={true}
                  setIsExternalLading={setIsLoadingFindUser}
                  setInitialDataWithPhoneService={getUserInfoesByPhoneNumber}
                  setIsFindUser={setIsFindUser}
                  disabled={isLoadingFindUser}
                  loading={isLoadingFindUser}
                  name="Phone"
                  required={true}
                  xs={24}
                  form={form}
                  placeholder={"Telefon Numarası"}
                  inputClass="!m-0  !h-[39px] !text-black"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                />
              </>
            )}
            <GeneralStoreInput
              xs={24}
              name={type==="edit-single-record"?"storeId":"storeIdList"}
              mode="tags"
              size="large"
              placeholder="Mağaza"
              label="Mağaza"
              rules={[{ required: true, message: "" }]}
            />
            {!selectedRecord && (
              <>
                <MazakaInput
                  xs={24}
                  lg={12}
                  disabled
                  label="Adı"
                  placeholder="Adı"
                  name="name"
                  size="large"
                  rules={[{ required: true, message: "" }]}
                />
                <MazakaInput
                  lg={12}
                  xs={24}
                  disabled
                  label="Soyadı"
                  placeholder="Soyadı"
                  size="large"
                  name="surname"
                  rules={[{ required: true, message: "" }]}
                />
                <MazakaInput
                  label="E-Posta"
                  disabled
                  placeholder="E-Posta"
                  name="eMail"
                  size="large"
                  xs={24}
                  rules={[
                    {
                      type: "email",
                      message: "E-Posta Formatı Geçersiz",
                    },
                    { required: true, message: "" },
                  ]}
                />
              </>
            )}
            {type !== "user" && (
              <MazakaSwitch
                label="İlan Verebilir Mi"
                name={"isAuthPostAdvert"}
                xs={24}
              />
            )}
            <MazakaSwitch label="Durum" name={"active"} xs={24} />

            <Col span={24} className="!flex gap-3 !items-center ">
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black !mt-4"
                htmlType="submit"
                processType={formActions.submitProcessType}
              >
                {selectedRecord ? "Güncelle" : "Davet et"}
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default AddOrUpdateUser;
